import React from 'react';

function MoreVerticle({ ...props }) {
    return (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7.19987 2.79895C7.19987 2.13621 7.73713 1.59895 8.39987 1.59895C9.06261 1.59895 9.59987 2.13621 9.59987 2.79895C9.59987 3.4617 9.06261 3.99895 8.39987 3.99895C7.73713 3.99895 7.19987 3.4617 7.19987 2.79895ZM7.19987 7.59895C7.19987 6.93621 7.73713 6.39895 8.39987 6.39895C9.06261 6.39895 9.59987 6.93621 9.59987 7.59895C9.59987 8.26169 9.06261 8.79895 8.39987 8.79895C7.73713 8.79895 7.19987 8.26169 7.19987 7.59895ZM8.39987 11.199C7.73713 11.199 7.19987 11.7362 7.19987 12.399C7.19987 13.0617 7.73713 13.599 8.39987 13.599C9.06261 13.599 9.59987 13.0617 9.59987 12.399C9.59987 11.7362 9.06261 11.199 8.39987 11.199Z"
                fill="currentColor"
            />
        </svg>
    );
}

export default MoreVerticle;
